import { formatJobTaskReferenceValue } from "tap/utils/formatJobTaskReferenceValue.js";

/**
 * Converts a single task field value to a React-safe display scalar.
 * Reference objects become formatted strings; other plain objects are JSON-stringified.
 * @param {unknown} value
 * @returns {unknown}
 */
export function scalarizeJobTaskFieldValue(value) {
  if (value == null || value === "") {
    return value;
  }

  if (typeof value !== "object" || value instanceof Date) {
    return value;
  }

  if (Array.isArray(value)) {
    return value
      .map((entry) => scalarizeJobTaskFieldValue(entry))
      .filter((entry) => entry != null && entry !== "")
      .map(String)
      .join("\n");
  }

  const referenceText = formatJobTaskReferenceValue(value);
  if (referenceText) {
    return referenceText;
  }

  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

/**
 * Clones a licensing job view task row and converts any object field values to
 * display-safe strings for AG Grid / React.
 * @param {Object} task
 * @returns {Object}
 */
export function normalizeLicensingJobViewTask(task) {
  if (!task || typeof task !== "object") {
    return task;
  }

  const normalized = { ...task };

  for (const key of Object.keys(normalized)) {
    const value = normalized[key];
    if (
      value != null &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      !(value instanceof Date)
    ) {
      normalized[key] = scalarizeJobTaskFieldValue(value);
    } else if (Array.isArray(value)) {
      normalized[key] = scalarizeJobTaskFieldValue(value);
    }
  }

  return normalized;
}

/**
 * @param {Array} tasks
 * @returns {Array}
 */
export function normalizeLicensingJobViewTasks(tasks) {
  if (!Array.isArray(tasks)) {
    return [];
  }

  return tasks.map(normalizeLicensingJobViewTask);
}
